import { HttpClient } from '@angular/common/http';
import { Injectable, Signal, signal } from '@angular/core';
import { Pagination } from 'app/core/models/pagination.model';
import { environment } from 'environments/environment';
import { Observable, tap } from 'rxjs';
import { backgroundRequest } from 'app/shared/services/loading/loading.context';

@Injectable({
  providedIn: 'root',
})
export class TimeZoneService {
  private _apiUrl = environment.apiUrlPrefix;
  private _timeZoneUrl = 'MasterConfigurations/iana/tz';

  private _timeZones = signal([] as any[]);
  private _pagination = signal({} as Pagination);

  constructor(private http: HttpClient) {}

  get timeZones$(): Signal<any[]> {
    return this._timeZones;
  }

  get pagination$(): Signal<Pagination> {
    return this._pagination;
  }

  getTimeZones(
    sortColumn: string = 'name',
    sortOrder: string = 'asc',
    searchString: string = '',
    pageNumber: number = 1,
    pageSize: number = 20,
    // Skip the app-wide loading splash: a search, page or sort refetch inside
    // the picker shows the table's own skeleton instead.
    background = false
  ): Observable<{
    pageIndex: number;
    totalPages: number;
    totalItems: number;
    items: any[];
    hasPreviousPage: boolean;
    hasNextPage: boolean;
  }> {
    return this.http
      .get<{
        pageIndex: number;
        totalPages: number;
        totalItems: number;
        items: any[];
        hasPreviousPage: boolean;
        hasNextPage: boolean;
      }>(`${this._apiUrl}${this._timeZoneUrl}`, {
        context: background ? backgroundRequest() : undefined,
        params: {
          sortColumn,
          sortOrder,
          searchString,
          pageNumber,
          pageSize,
        },
      })
      .pipe(
        tap((response) => {
          const { pageIndex, totalPages, totalItems, items, hasPreviousPage, hasNextPage } =
            response;
          this._pagination.set({
            pageIndex,
            totalPages,
            totalItems,
            hasPreviousPage,
            hasNextPage,
          });
          this._timeZones.set(items);
        })
      );
  }
}
